import React from "react";
import { Link } from "react-router-dom";
import "../../common/Fiche/fiche-kit.scss";

// Page introuvable : carte sur le fond de page, lien vers l'accueil.
const NotFound = () => {
  return (
    <div className="page-introuvable">
      <section className="list-card page-introuvable__carte" aria-labelledby="titre-introuvable">
        <p className="page-introuvable__code" aria-hidden="true">
          404
        </p>
        <h1 id="titre-introuvable" className="page-introuvable__titre">
          Cette page n'existe pas
        </h1>
        <p className="page-introuvable__aide">
          L'adresse est peut-être mal recopiée, ou la page a été déplacée.
        </p>
        <Link to="/" className="btn btn-primary">
          <i className="fa fa-arrow-left mr-2" aria-hidden="true" />
          Revenir à l'accueil
        </Link>
      </section>
    </div>
  );
};

export default NotFound;
